export default "__VITE_ASSET__BnQzWETY__"